module.exports = __webpack_public_path__ + "media/svg/sb-8062ca05.svg";